import { createApp } from "vue"
import { Swiper, SwiperSlide } from "swiper/vue"
import { Navigation, Pagination, Scrollbar, FreeMode, Thumbs, Grid } from "swiper"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/scrollbar"
import "swiper/css/grid"
import { Modal } from "bootstrap"

const app = createApp({
    components: {
        Swiper,
        SwiperSlide,
        Modal,
    },
    setup() {
        /**
         * Altera o hash para a seção ativa
         */
        return {
            Navigation,
            Pagination,
            Scrollbar,
            FreeMode,
            Thumbs,
            Grid,
        }
    },
    data() {
        return {
            activeSectionHash: "sobre",
            fixedTabs: false,
            expandServices: false,
            expandComodidades: false,
            toggleAboutText: false,
            toggleOpeningTimes: false,
            toggleGallery: true,
            modal: null,
            modalElement: null,
            swiperOptions: {
                tabs: {},
                offers: {
                    ref: null,
                    slidesOffsetAfter: 12,
                    breakpoints: {
                        0: {
                            slidesPerView: 1.2,
                            grid: {
                                rows: 2,
                                fill: "row",
                            },
                        },
                        480: {
                            slidesPerView: 1.5,
                            grid: {
                                rows: 2,
                                fill: "row",
                            },
                        },
                        640: {
                            slidesPerView: 1.8,
                            grid: {
                                rows: 2,
                                fill: "row",
                            },
                        },
                        1024: {
                            slidesPerView: 3,
                            grid: {
                                rows: 2,
                                fill: "row",
                            },
                        },
                        1280: {
                            slidesPerView: 3,
                            grid: {
                                rows: 2,
                                fill: "row",
                            },
                        },
                    },
                },
            },
            gallery: {
                visible: false,
                currentIndex: 0,
                totalItems: 0,
                mainGallery: null,
                thumbGallery: null,
            },
            mapa: {
                nome: null,
                latitude: null,
                longitude: null,
                referencia: null,
                endereco: null,
            },
            catalog: {
                url: null,
                filename: null,
                isImage: false,
                isPdf: false,
            },
        }
    },
    mounted() {
        window.addEventListener("hashchange", (ev) => {
            this.activeSectionHash = window.location.hash
                .slice(1)
                .replace("#", "")
        })

        const hero = document.querySelector(".hero")
        const sections = document.querySelectorAll("section[id]")

        window.addEventListener("scroll", () => {
            const bounding = hero.getBoundingClientRect()

            this.fixedTabs = bounding.top * -1 >= bounding.height

            // Detect active section
            let current = this.activeSectionHash
            sections.forEach((section) => {
                const rect = section.getBoundingClientRect()
                if (rect.top <= 100 && rect.bottom >= 100) {
                    current = section.id
                }
            })
            this.activeSectionHash = current
        })

        this.modalElement = document.getElementById("galeriaModal")

        this.modal = new Modal(this.modalElement)

        this.modalElement.addEventListener("hidden.bs.modal", () => {
            this.gallery.visible = false

            //this.stopVideo()
        })

        // Listener para modal de catálogos
        const catalogModalElement = document.getElementById("catalogModal")
        if (catalogModalElement) {
            catalogModalElement.addEventListener("hidden.bs.modal", () => {
                this.catalog = {
                    url: null,
                    filename: null,
                    isImage: false,
                    isPdf: false,
                }
            })
        }
    },
    methods: {
        openGallery(index, video = false) {
            this.gallery.visible = true
            this.gallery.currentIndex = index

            const modal = new Modal(document.getElementById("galeriaModal"))
            modal.show()

            this.$nextTick(() => {
                if (this.gallery.mainGallery)
                    this.gallery.mainGallery.slideTo(index, 0)

                if (video) {
                    const iframe = document.querySelector(
                        ".company-video.full iframe"
                    )

                    if (iframe && iframe.getAttribute("data-src")) {
                        iframe.setAttribute(
                            "src",
                            iframe.getAttribute("data-src") + "?autoplay=1"
                        )
                    }
                }
            })
        },
        onGallerySlideChange(event) {
            this.gallery.totalItems = event.slides.length
            this.gallery.currentIndex = event.activeIndex

            this.$nextTick(() => {
                this.gallery.thumbGallery?.slideTo(event.activeIndex)
            })
        },
        setMainGallerySwiper(swiper) {
            this.gallery.mainGallery = swiper
        },
        setThumbGallerySwiper(swiper) {
            this.gallery.thumbGallery = swiper
        },
        galleryNext() {
            this.gallery.mainGallery?.slideNext()
        },
        galleryPrev() {
            this.gallery.mainGallery?.slidePrev()
        },
        activeSection(hash) {
            return this.activeSectionHash === hash
        },
        offersLoad(swiper) {
            this.swiperOptions.offers.ref = swiper
        },
        offersNext() {
            this.swiperOptions.offers.ref?.slideNext()
        },

        offersPrev() {
            this.swiperOptions.offers.ref?.slidePrev()
        },
        openMaps(empresa) {
            this.mapa = empresa
            const modal = new Modal(document.getElementById("mapsModal"))
            modal.show()
        },
        stopVideo(n) {
            const iframe = document.querySelector(".company-video.full iframe")

            if (iframe) iframe.setAttribute("src", null)
        },
        openPhonesModal() {
            const modal = new Modal(document.getElementById("phonesModal"))
            modal.show()
        },
        openCatalog(url, filename) {
            // Detect file type
            const extension = filename.split('.').pop().toLowerCase()
            const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp']

            this.catalog = {
                url: url,
                filename: filename,
                isImage: imageExtensions.includes(extension),
                isPdf: extension === 'pdf',
            }

            const modal = new Modal(document.getElementById("catalogModal"))
            modal.show()
        },
    },
})

app.mount("#landing-gold")
